<template>
  <div class="lego-select-table-wrap">
    <div style="width: 220px; border-right: 1px solid #e3e5e8">
      <lego-card :height="height">
        <div class="lego-card-header">
          <b>{{ labelNamePrefix + $t('label.name') }}</b>
        </div>
        <div class="lego-card-body">
          <c-scroll style="height: 100%">
            <div v-for="(productItem, idx) in productItems" :key="idx">
              <div
                :class="productItemId === idx ? ['selected'] : []"
                class="lego-card-body-item"
                @click="onClickProductItem(idx, productItem)"
              >
                <span>{{ productItem.name }}</span>
                <span class="badge-selected" v-if="productItem.numSelected">
                  {{ productItem.numSelected }}
                </span>
              </div>
            </div>
          </c-scroll>
        </div>
      </lego-card>
    </div>
    <div style="width: calc(100% - 220px); padding-left: 20px">
      <div>
        <lego-table
          ref="list"
          :style="`height: ${height}px`"
          title
          multiSelect
          selectAll
          tableFixed
          v-model="tableSelectedItems"
          :items="viewItems"
          :headers="headers"
          :selectActionControl="false"
          :scrollMaxRow="scrollMaxRow"
          :selectMaxCnt="selectMaxItem - getNotExistTableCardsCount"
          :messageMaxCnt="$t('page.performance.monitoringTargetMaxLimite', { max: selectMaxItem })"
          :noPage="true"
          :noControl="false"
          @update:modelValue="onCheck"
          @inputAll="onCheck"
          @sort="onSort"
        ></lego-table>
      </div>
    </div>
  </div>
</template>
<script>
import { PREFIX_MAP_PRODUCT_TYPES_V2 } from '@/containers/utils/constant.js';

const DEFAULT_STYLE = {
  height: 268
};

const k8S_LIST = ['Kubernetes', 'DataWrangler', 'QuickQuery'];

export default {
  name: 'AddMonitorTargetSubItem',
  props: {
    searchText: {
      type: String,
      default: ''
    },
    objectTypeName: {
      type: String,
      default: ''
    },
    monitorInfo: {
      type: Object,
      default: () => {
        return {
          pProductTypeCode: '',
          pProductTypeName: '',
          pProductTypeCodes: [],
          pObjectTypeCode: ''
        };
      }
    },
    height: {
      type: Number,
      default: () => DEFAULT_STYLE.height
    },
    scrollFixRow: {
      type: Number,
      default: 6
    },
    scrollMaxRow: {
      type: Number,
      default: 6
    },
    selectMaxItem: {
      type: Number,
      default: 10
    },
    searchDate: {
      type: Object
    }
  },
  computed: {
    headers() {
      let headers = [
        {
          text: this.objectTypeName + this.$t('label.name'),
          value: 'objectDisplayName',
          width: '100%',
          sortable: true,
          defaultValue: '-'
        }
      ];
      if (this.productTypeCode === 'DataOps' || this.productTypeCode === 'DataFlow') {
        headers = [
          {
            text: this.$t('header.podName'),
            value: 'objectDisplayName',
            width: 170,
            sortable: true,
            defaultValue: '-'
          },
          {
            text: this.$t('header.purpose'),
            value: 'podLabel',
            width: 170,
            sortable: true,
            defaultValue: '-'
          },
          {
            text:
              this.productTypeCode === 'DataOps'
                ? this.$t('searchLabel.dataOpsName')
                : this.$t('searchLabel.dataFlowName'),
            value: 'managerName',
            width: 200,
            sortable: true,
            defaultValue: '-'
          }
        ];
      }
      if (this.productTypeCode === 'DataWrangler' || this.productTypeCode === 'QuickQuery') {
        headers = [
          {
            text: this.$t('header.podName'),
            value: 'objectName',
            width: 400,
            sortable: true,
            defaultValue: '-'
          }
        ];
      }
      return headers;
    },
    viewItems() {
      return this.items.filter((v) =>
        v.objectDisplayName.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
    getNotExistTableCardsCount() {
      const TABLE_LIST = this.tableSelectedItems.map((o) => o.resourceId + o.objectName);
      return this.selectedCardItems.filter((o) => !TABLE_LIST.includes(o.resourceId + o.objectName))
        .length;
    },
    labelNamePrefix() {
      return PREFIX_MAP_PRODUCT_TYPES_V2[this.productTypeCode];
    }
  },
  data() {
    return {
      productTypeCode: '',
      tableSelectedItems: [],
      selectedCardItems: [],
      selectedOrgItems: [],
      items: [],
      productItems: [],
      productItemId: 0,
      noDataText: ''
    };
  },
  created() {
    this.init();
  },
  watch: {
    selectedCardItems: {
      deep: true,
      handler(selects) {
        this.setNumberSelected();
      }
    }
  },
  methods: {
    init() {
      this.productTypeCode = this.monitorInfo.pProductTypeCode;
      this.selectedCardItems = this.$util.deepCopy(this.monitorInfo.pProductTypeCodes);
      this.getSummaries();
      this.$emit('onCheck', this.selectedCardItems);
    },
    //모니터링 대상 목록조회
    getSummaries(param) {
      param = param || {};
      this.$http.product
        .getSummaries(param, this.productTypeCode, true)
        .then((data) => {
          this.productItems = data.map((item) => {
            return {
              ...item,
              productResourceId: item.resourceId,
              name: item.productName,
              sq: item.productSq,
              numSelected: 0
            };
          });
          this.onSort({ value: 'productName', asc: true }, true);

          this.setNumberSelected();

          let productItem = this.productItems[0];
          if (this.selectedCardItems.length > 0) {
            productItem = this.selectedCardItems[0];
            productItem.sq = productItem.productSq;
            this.productItemId = this.productItems.findIndex(
              (v) => v.resourceId === productItem.resourceId
            );
            this.productItemId = this.productItemId < 0 ? 0 : this.productItemId;
          }
          if (productItem) {
            this.getObjectList(productItem);
          }
        })
        .catch((e) => {
          this.$emit('clearSearchText');
          if (e && e.code == 'AccessDenied') {
            this.noDataText = 'message.listMonitorAccessError'; // listMonitor 권한이 필요
            this.productItems = [];
            this.items = [];
            this.$alert(e);
          }
        });
    },

    setNumberSelected() {
      this.productItems.forEach((product) => {
        const lstSelected = this.selectedCardItems.filter(
          (select) => select.resourceId == product.resourceId
        );
        product.numSelected = lstSelected.length;
      });
    },

    getObjectList(productItem) {
      let params = {
        productObjectType: this.monitorInfo.pObjectTypeCode,
        [k8S_LIST.includes(this.productTypeCode) ? 'productIdList' : 'productIds']: [productItem.sq]
      };

      if (this.searchDate) {
        params.queryEndDt = this.searchDate.queryEndDt || '';
        params.queryStartDt = this.searchDate.queryStartDt || '';
      }

      const payload = {
        productTypeCode: this.productTypeCode,
        params,
        listDataCheckAuth: [
          {
            productResourceId: productItem.sq,
            productName: productItem.name
          }
        ]
      };

      this.$store.dispatch('authStore/checkAuthorizationCluster', payload).then((response) => {
        if (response.type === this.$const.AuthorizationResult.ALLOW) {
          const data = k8S_LIST.includes(this.productTypeCode)
            ? response.responseData
            : response.responseData.contents;
          data.forEach((obj) => {
            this.items.push({
              sq: productItem.sq,
              productSq: productItem.sq,
              name: productItem.name || productItem.productName,
              productName: productItem.name || productItem.productName,
              resourceId: obj.productResourceId,
              objectDisplayName: obj.objectDisplayName,
              managerName: obj.managerName,
              podLabel: obj.podLabel,
              objectName: obj.objectName,
              objectType: obj.objectType,
              check: true,
              idx: this.productItems.findIndex((p) => p.name === productItem.name)
            });
          });
          if (data.length > 0) {
            this.checkSelectedItem();
            this.onSort({ value: 'objectDisplayName', asc: true });
          }
        } else {
          this.noDataText = 'message.listMonitorAccessError'; // listMonitor 권한이 필요
          this.items = [];
          this.tableSelectedItems = [];
        }
      });
    },

    checkSelectedItem() {
      let _codes = [];
      this.selectedCardItems.forEach((item) => {
        const findItem = this.items.find(
          (_row) => _row.resourceId + _row.objectName == item.resourceId + item.objectName
        );
        if (findItem) _codes.push(findItem);
      });
      this.tableSelectedItems = _codes;
    },
    async onCheck(selectedItems, targetMaxCheck) {
      if (targetMaxCheck) return;

      const TABLE_LIST = this.items.map((o) => o.resourceId + o.objectName);
      const NOT_INCLUDE_CARD_LIST = this.selectedCardItems.filter(
        (o) => !TABLE_LIST.includes(o.resourceId + o.objectName)
      );

      selectedItems = [...NOT_INCLUDE_CARD_LIST, ...selectedItems];

      if (this.selectedCardItems.length < selectedItems.length) {
        const productResourceIds = selectedItems.map((v) => v.resourceId);
        const listDataCheckAuth = selectedItems.map((v) => {
          return {
            productResourceId: v.resourceId,
            productName: v.productName
          };
        });
        const param = {
          productTypeCode: this.productTypeCode,
          actionName: this.$const.AuthorizationAction.MONITOR_VIEW,
          productResourceIds,
          listDataCheckAuth
        };

        const data = await this.$store.dispatch('authStore/checkProductResource', param);

        if (data.type === this.$const.AuthorizationResult.ALLOW) {
          this.selectedCardItems = selectedItems;
          this.$emit('onCheck', selectedItems);
          return;
        }

        //Function for check resource ids error, if it exits, it doesn't need to check others target
        if (!data.resourceIds || !data.resourceIds.length) return;

        const remainSelected = this.tableSelectedItems.filter(
          (item) =>
            !data.resourceIds.includes(item['resourceId']) &&
            !data.resourceIds.includes(item['productName'])
        );

        this.$refs.list.selected = remainSelected;
        this.tableSelectedItems = remainSelected;

        await this.onCheck(remainSelected, targetMaxCheck);

        this.$emit('onCheck', remainSelected);
      } else {
        this.selectedCardItems = selectedItems;
        this.$emit('onCheck', selectedItems);
      }
    },
    onSort({ asc, value }, isParent = false) {
      const { ASC: _ASC, DESC: _DESC } = this.$const.SORT_TYPES;
      const propName = isParent ? 'productItems' : 'items';
      this[propName] = this.$util.customSort(this[propName], value, asc ? _ASC : _DESC);
    },
    onClickProductItem(id, productItem) {
      this.items = [];
      this.tableSelectedItems = [];
      this.productItemId = id;
      this.getObjectList(productItem);
    },
    deleteCard(item) {
      this.tableSelectedItems = this.tableSelectedItems.filter(
        (o) => o.resourceId + o.objectName !== item.resourceId + item.objectName
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.lego-card-body {
  height: calc(100% - 32px);
}

.lego-card-header {
  display: flex;
  align-items: center;
  height: 32px;
}

.lego-select-table-wrap {
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-top: 20px;
  min-height: calc(100% - 76px);
}

.badge-selected {
  width: 20px;
  height: 20px;
  border: 1px solid #2c59d9;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  margin-left: 8px;
  font-size: 12px;
  line-height: 12px;
  color: #2c59d9;
  font-weight: bold;
}

.lego-card-body-item {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 14px;
  cursor: pointer;
  padding: 0 10px;
  margin-right: 12px;
  justify-content: space-between;
}

.lego-card-body-item.selected {
  border-radius: 4px;
  margin-right: 12px;
  background-color: rgba(54, 79, 199, 0.12);
  color: var(--blue-with-a-hint-of-purple);
}

::v-deep .lego-table__top {
  margin-bottom: 3px !important;
}

::v-deep .simplebar-content {
  width: 100% !important;
  padding: 0px 1px 0px 1px !important;
}

::v-deep .lego-card {
  border: unset;
}
</style>
